import { useEffect } from "react";
import "halloween.js";
import halloweenConfig, {
  buildHalloweenClasses,
} from "../config/halloweenConfig";

const mergeHalloweenConfig = (overrides = {}) => ({
  ...halloweenConfig,
  ...overrides,
  season: {
    ...halloweenConfig.season,
    ...overrides.season,
  },
  corners: overrides.corners || halloweenConfig.corners,
  effects: {
    ...halloweenConfig.effects,
    ...overrides.effects,
  },
});

const restoreAttribute = (element, name, previousValue) => {
  if (previousValue === null) {
    element.removeAttribute(name);
  } else {
    element.setAttribute(name, previousValue);
  }
};

function useHalloween(overrides) {
  const configKey = JSON.stringify(mergeHalloweenConfig(overrides));

  useEffect(() => {
    const config = JSON.parse(configKey);
    if (
      typeof document === "undefined" ||
      !config.enabled ||
      !document.body
    ) {
      return undefined;
    }

    const body = document.body;
    const classes = buildHalloweenClasses(config);
    const addedClasses = classes.filter(
      (className) => !body.classList.contains(className),
    );
    const previousStart = body.getAttribute("data-halloween-start");
    const previousEnd = body.getAttribute("data-halloween-end");
    const previousColor = body.style.getPropertyValue("--halloween-color");

    body.setAttribute("data-halloween-start", config.season.start);
    body.setAttribute("data-halloween-end", config.season.end);
    if (config.color) {
      body.style.setProperty("--halloween-color", config.color);
    } else {
      body.style.removeProperty("--halloween-color");
    }
    body.classList.add(...classes);

    return () => {
      addedClasses.forEach((className) => body.classList.remove(className));
      restoreAttribute(body, "data-halloween-start", previousStart);
      restoreAttribute(body, "data-halloween-end", previousEnd);
      if (previousColor) {
        body.style.setProperty("--halloween-color", previousColor);
      } else {
        body.style.removeProperty("--halloween-color");
      }
    };
  }, [configKey]);
}

export default useHalloween;
